import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "pp_cookie_ack_v1";

// Banner cookie: il portale usa SOLO cookie tecnici → semplice presa visione.
export function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setShow(true); } catch { /* */ }
  }, []);
  const accept = () => {
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch { /* */ }
    setShow(false);
  };
  if (!show) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-40 p-3 sm:p-4" data-testid="cookie-banner">
      <div className="pointer-events-auto mx-auto flex max-w-4xl flex-col gap-3 rounded-xl border border-border/60 bg-white/95 p-4 shadow-lg backdrop-blur sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-sage text-forest"><Cookie className="h-4 w-4" /></span>
          <p className="text-xs leading-relaxed text-muted-foreground">
            Questo portale utilizza <b>esclusivamente cookie tecnici</b> necessari al suo funzionamento (nessuna profilazione).
            Continuando la navigazione ne prendi atto. Maggiori dettagli nella{" "}
            <a href="/cookie" target="_blank" rel="noopener noreferrer" className="text-terracotta underline">Cookie Policy</a>.
          </p>
        </div>
        <Button onClick={accept} data-testid="cookie-accept" className="shrink-0 rounded-full bg-forest hover:bg-forest/90">
          Ho capito
        </Button>
      </div>
    </div>
  );
}
